module.exports = __webpack_public_path__ + "img/3f412510f17fc47d5004550f070567bd.png";